import * as React from 'react';
import { navigate } from 'gatsby';
import { isLoggedIn } from '../authService/auth';
import { PATH_PAGE } from '../../routes/paths';
import StatrysLoader from '../ui/loaders/StatrysLoader';
import { MARKETING_LOGIN_URL } from '../../constants/enum';

const PrivateRoute = ({ component: Component, location, ...rest }) => {
  if (!isLoggedIn() && location.pathname !== PATH_PAGE.login) {
    navigate(MARKETING_LOGIN_URL);
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <StatrysLoader />
      </div>
    );
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
